import axiosInstance from '@/services/Api';
import TokenService from '@/services/TokenService';
import { displayToast } from '@/components/utils/globalFunction'
import i18n from '@/i18n/config'

const { t } = i18n.global
import router from '@/router'

const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken()
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      const originalConfig = error.config

      if (originalConfig.url !== '/auth/login'
        && originalConfig.url !== '/auth/refresh-token'
        && originalConfig.url !== '/auth/logout'
        && originalConfig.url !== '/auth/me'
        && error.response) {
        // Access Token was expired
        if (error.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true

          try {
            const response = await axiosInstance.post('/auth/refresh-token', {
              refreshToken: TokenService.getLocalRefreshToken()
            })

            const accessToken = response.data.access_token

            store.dispatch('auth/refreshToken', accessToken)
            TokenService.updateLocalAccessToken(accessToken)

            return axiosInstance(originalConfig)
          } catch (_error) {
            await store.dispatch('auth/interceptorLogout', { router })
            return Promise.reject(_error)
          }
        } else if (error.response.status === 403) {
          await store.dispatch('auth/me')
          displayToast(t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'error')
          await router.push({ path: '/dashboard', query: { skip: 'true' } })
          return Promise.reject()
        }
      }

      return Promise.reject(error)
    }
  )
}

export default setup
